const trimFirstAndLastChars = (ndc: string) => {
  const ndcLength = ndc.length;
  return ndc.substring(1, ndcLength - 1);
};

const NON_DIGIT_GLOBAL = /\D/g;

export const stripNdcDashes = (ndc: string) => ndc.replace(/-/g, "");

const removeHyphens = (ndc: string) => stripNdcDashes(ndc);

export const clampNdcInputElevenDigits = (value: string): string => {
  const digits = stripNdcDashes(value).replace(NON_DIGIT_GLOBAL, "").slice(0, 11);
  if (digits.length <= 5) {
    return digits;
  }
  if (digits.length <= 9) {
    return `${digits.slice(0, 5)}-${digits.slice(5)}`;
  }
  return `${digits.slice(0, 5)}-${digits.slice(5, 9)}-${digits.slice(9)}`;
};

export const applyNdcInputChange = (
  previous: string,
  next: string,
  options?: { lockDashes?: boolean }
): string => {
  const prevDigits = stripNdcDashes(previous).replace(NON_DIGIT_GLOBAL, "");
  const nextDigits = stripNdcDashes(next).replace(NON_DIGIT_GLOBAL, "").slice(0, 11);

  if (
    options?.lockDashes &&
    previous.includes("-") &&
    prevDigits.length > 0 &&
    prevDigits === nextDigits
  ) {
    return clampNdcInputElevenDigits(nextDigits);
  }

  return next;
};

export const formatNdc = (ndc: string): string => {
  const trimmedNdc = ndc.trim();
  const noHyphensNdc = removeHyphens(trimmedNdc);
  const ndcLength = noHyphensNdc.length;
  let formattedNdc: string;
  if (ndcLength > 11) {
    formattedNdc = trimFirstAndLastChars(noHyphensNdc);
  } else {
    formattedNdc = noHyphensNdc;
  }
  return formattedNdc;
};
export const isNdcValid = (ndc: string) => {
  if (!ndc || typeof ndc !== "string") return false;
  
  const formattedNdc = formatNdc(ndc);
  const formattedNdcLength = formattedNdc.length;

  if (formattedNdcLength < 9 || formattedNdcLength > 11) return false;
  return true;
};

/** True when NDC is complete enough for a drug lookup (10- or 11-digit). */
export const isNdcReadyForDrugLookup = (ndc: string) => {
  if (!isNdcValid(ndc)) return false;
  const len = formatNdc(ndc).length;
  return len === 10 || len === 11;
};

/** GS1/QR streams (prefix 01 or length > 15) complete on Enter. */
export const isGs1StreamInProgress = (value: string) => {
  const trimmed = value.trim();
  if (trimmed.length > 15) return true;
  return trimmed.replace(/-/g, "").startsWith("01");
};

/** Arm the barcode idle timer only for short numeric wedge scans. */
export const shouldArmBarcodeScanTimer = (value: string) => {
  const trimmed = value.trim();
  if (!trimmed) return false;
  if (isGs1StreamInProgress(trimmed)) return false;

  const dashless = trimmed.replace(/-/g, "");
  return /^\d+$/.test(dashless);
};
